import * as Yup from 'yup'
import {BaseEntity} from '../../../../shared/models/ApiModels'

/** hr_process tablosu */
export interface IHrProcessModel extends BaseEntity {
  name: string
}

export const validationHrProcess = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('Süreç adı zorunludur')
    .max(255, 'Süreç adı en fazla 255 karakter olabilir'),
})

export const initialHrProcess: IHrProcessModel = {
  id: '',
  name: '',
}
